var _a;
var ENV = (_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : 'development';
export var IS_DEV = ENV === 'development';
